import classNames from "classnames";
import Mousetrap from "mousetrap";
import React from "react";
import { FormControl, Glyphicon, Row, Col, Table } from "react-bootstrap";
import $ from "jquery";
import _ from "lodash";

import BudgetStore from "../stores/BudgetStore";
import CategoryStore from "../stores/CategoryStore";
import CurrencyStore from "../stores/CurrencyStore";
import UserStore from "../stores/UserStore";

import BudgetActions from "../actions/BudgetActions";
import CategoryActions from "../actions/CategoryActions";

import AccountingHelper from "../utils/AccountingHelper";

import BudgetAllocationEdit from "./BudgetAllocationEdit";
import BudgetAudit from "./BudgetAudit";

const placeholder = document.createElement("tr");
const placeholderCell = document.createElement("td");
placeholderCell.colSpan = 3;
placeholder.className = "placeholder";
placeholder.appendChild(placeholderCell);

export default class Budget extends React.Component
{
	constructor(props)
	{
		super(props);

		let state = Budget.getStoreState();
		state.showBudgetAuditModal = false;
		state.showEditModal = false;
		state.showItemsWithAmountZero = false;
		state.historyCategoryId = null;
		state.historyCurrencyId = null;
		state.filterTemplateId = null;
		this.state = state;

		this._onChange = this._onChange.bind(this);
		this.handleFilterTemplateChange = this.handleFilterTemplateChange.bind(this);
		this.handleShowBudgetAuditModal = this.handleShowBudgetAuditModal.bind(this);
		this.handleBudgetAuditModalClose = this.handleBudgetAuditModalClose.bind(this);
		this.handleAllocationEditModalClose = this.handleAllocationEditModalClose.bind(this);
		this.handleShowAllocationEditModal = this.handleShowAllocationEditModal.bind(this);
		this.handleShowItemsWithAmountZeroToggle = this.handleShowItemsWithAmountZeroToggle.bind(this);

		this.handleDragOver = this.handleDragOver.bind(this);
		this.handleDragEnd = this.handleDragEnd.bind(this);
		this.handleDragStart = this.handleDragStart.bind(this);
	}

	static getStoreState()
	{
		var state = {
			budgetAllocations: BudgetStore.getAllocations(),
			budgetOrdering: UserStore.getUserProfileSetting("budgetOrdering"),
			budgetTemplates: BudgetStore.getTemplates(),
			categories: CategoryStore.getCategories()
		};

		if (UserStore.areMultipleCurrenciesEnabled())
		{
			state.areMultipleCurrenciesEnabled = true;
			state.currencies = CurrencyStore.getCurrencies();
		}

		return state;
	}

	handleShowBudgetAuditModal(historyCategoryId, historyCurrencyId)
	{
		this.setState({
			showBudgetAuditModal: true,
			historyCategoryId,
			historyCurrencyId
		});
	}

	handleBudgetAuditModalClose()
	{
		this.setState({
			showBudgetAuditModal: false,
			historyCategoryId: null
		});
	}

	handleShowBudgetModal(editTemplate)
	{
		this.setState({
			showBudgetModal: true,
			editTemplate: editTemplate || null
		});
	}

	handleBudgetModalClose()
	{
		this.setState({
			showBudgetModal: false,
			editTemplate: null
		});
	}

	handleShowAllocationEditModal()
	{
		this.setState({
			showEditModal: true
		});
	}

	handleAllocationEditModalClose()
	{
		this.setState({
			showEditModal: false
		});
	}

	handleFilterTemplateChange(event)
	{
		let value = +event.currentTarget.value;
		if (!value)
		{
			value = null;
		}
		this.setState({filterTemplateId: value});
	}

	handleShowItemsWithAmountZeroToggle()
	{
		this.setState({
			showItemsWithAmountZero: !this.state.showItemsWithAmountZero
		});
	}

	handleDragStart(event)
	{
		const $currentRow = $(event.currentTarget).closest(".draggable-row");
		this.dragged = $currentRow[0];
		event.dataTransfer.effectAllowed = "move";

		// Firefox requires calling dataTransfer.setData
		// for the drag to properly work
		event.dataTransfer.setData("text/html", event.currentTarget);
	}

	handleDragEnd()
	{
		this.dragged.style.display = "table-row";
		const parent = this.dragged.parentNode;
		const $dragHandle = $(this.dragged).find(".drag-handle");
		parent.removeChild(placeholder);

		const categoryId = Number(this.dragged.dataset.category);

		// Update state
		const budgetItems = this.state.budgetAllocations;
		const from = Number($dragHandle[0].dataset.sequence);
		let to = Number(this.over.dataset.sequence);
		if (from < to)
		{
			to--;
		}
		if (this.nodePlacement === "after")
		{
			to++;
		}

		budgetItems.forEach(item =>
		{
			if (item.categoryId === categoryId)
			{
				item.sequence = to;
			}
			else if (item.sequence >= from && item.sequence <= to)
			{
				item.sequence = item.sequence - 1;
			}
			else if (item.sequence <= from && item.sequence >= to)
			{
				item.sequence = item.sequence + 1;
			}
		});

		// Optimistic render
		this.setState({ budgetAllocations: budgetItems }, async () =>
		{
			// Once the optimistic render is done, make a call to the backend to update the data
			await BudgetActions.setBudgetAllocationOrder(categoryId, to);
		});
	}

	handleDragOver(event)
	{
		event.preventDefault();
		this.dragged.style.display = "none";
		if (event.target.className === "placeholder")
		{
			return;
		}
		const $currentRow = $(event.target).closest(".draggable-row");
		if (!$currentRow.length)
		{
			// Not dragging over a proper element.
			return;
		}
		const currentRow = $currentRow[0];
		this.over = $currentRow.find(".drag-handle")[0];
		const relY = event.clientY - $currentRow.offset().top;
		const height = $currentRow.height() / 2;
		const parent = currentRow.parentNode;

		if (relY > height)
		{
			this.nodePlacement = "after";
			parent.insertBefore(placeholder, currentRow.nextElementSibling);
		}
		else if (relY < height)
		{
			this.nodePlacement = "before";
			parent.insertBefore(placeholder, currentRow);
		}
	}

	_onChange()
	{
		this.setState(Budget.getStoreState());
	}

	componentDidMount()
	{
		UserStore.addChangeListener(this._onChange);

		BudgetStore.addChangeListener(this._onChange);
		BudgetActions.initialize();

		CategoryStore.addChangeListener(this._onChange);
		CategoryActions.initialize();

		Mousetrap.bind("m", "Move Money", () =>
		{
			if (!this.state.showEditModal)
			{
				this.handleShowAllocationEditModal();
			}
		}, "keyup");
	}

	componentWillUnmount()
	{
		Mousetrap.unbind("m");
		UserStore.removeChangeListener(this._onChange);
		BudgetStore.removeChangeListener(this._onChange);
		CategoryStore.removeChangeListener(this._onChange);
	}

	render()
	{
		let budgetItems = this.state.budgetAllocations;
		const {categories, currencies, filterTemplateId, showItemsWithAmountZero, budgetTemplates, historyCurrencyId} = this.state;
		const canRenderTemplates = !!(budgetTemplates && budgetTemplates.length && categories && categories.length);
		if (canRenderTemplates && filterTemplateId)
		{
			const filterTemplate = budgetTemplates.find(budgetTemplate => budgetTemplate.id === filterTemplateId);
			if (filterTemplate && Array.isArray(filterTemplate.allocations))
			{
				const validCategories = filterTemplate.allocations.map(allocation => allocation.categoryId);
				budgetItems = budgetItems.filter(budgetItem => validCategories.includes(budgetItem.categoryId));
			}
		}
		const canRender = !!(budgetItems && budgetItems.length && categories && categories.length);
		const historyCategory = this.state.historyCategoryId ? categories.find(cat => cat.id === this.state.historyCategoryId) : null;
		let budgetOrdering = this.state.budgetOrdering || "amount:asc";
		if (canRender)
		{
			let sortParts = budgetOrdering.split(":");

			switch (sortParts[0])
			{
				case "amount":
					budgetItems = _.orderBy(budgetItems, (budgetItem) => {
						return budgetItem.amount;
					}, sortParts[1]);
					break;
				case "name":
					budgetItems = _.orderBy(budgetItems, (budgetItem) => {
						let category = categories.find(cat => cat.id === budgetItem.categoryId);
						return category.name;
					}, sortParts[1]);
					break;
				case "user":
					budgetItems = _.sortBy(budgetItems, (budgetItem) => {
						return budgetItem.sequence;
					});
			}
		}

		return (
			<Row>
				{this.state.showEditModal &&
					<BudgetAllocationEdit
						onClose={this.handleAllocationEditModalClose}
						budgetItems={budgetItems}
						currencies={currencies}
					/>
				}
				{this.state.showBudgetAuditModal &&
					<BudgetAudit
						onClose={this.handleBudgetAuditModalClose}
						category={historyCategory}
						currencyId={historyCurrencyId}
					/>
				}
				<Col xs={8} xsOffset={2} onDragOver={this.handleDragOver}>
					<Row>
						<Col xs={12}>
							<button className="btn btn-primary" onClick={this.handleShowAllocationEditModal}>Move Money</button>
							{/* TODO: clean up the display on this */}
							<label><input type="checkbox" checked={showItemsWithAmountZero} onChange={this.handleShowItemsWithAmountZeroToggle} />Show items with 0 amount</label>
						</Col>
					</Row>
					{canRenderTemplates &&
						<Row>
							<Col xs={4}>
								<label>Filter Categories by Template:</label>
							</Col>
							<Col xs={8}>
								<FormControl
									componentClass="select"
									value={filterTemplateId || ""}
									onChange={this.handleFilterTemplateChange}
								>
									<option value="" />
									{budgetTemplates.map(budgetTemplate => {
										return (
											<option key={budgetTemplate.id} value={budgetTemplate.id}>
												{budgetTemplate.description}
											</option>
										);
									})}
								</FormControl>
							</Col>
						</Row>
					}
					<Table>
						<thead>
							<tr>
								<th className={`col-md-1`} />
								<th className={`col-md-2`}>Amount</th>
								<th className={`col-md-9`}>Category</th>
							</tr>
						</thead>
						<tbody>
							{canRender && budgetItems.filter(bi => showItemsWithAmountZero === true || bi.amount != 0).map(budgetItem => {
								let category = categories.find(cat => cat.id === budgetItem.categoryId);
								let key = `${budgetItem.categoryId}`;
								if (!!budgetItem.currencyId) {
									key += `-${budgetItem.currencyId}`;
								}

								return (
									<tr
										key={key}
										data-category={budgetItem.categoryId}
										className={classNames({"draggable-row": budgetOrdering==="user"})}
									>
										<td>
											{budgetOrdering === "user" &&
												<div style={{position: "relative"}}>
													<Glyphicon
														data-sequence={budgetItem.sequence}
														className="drag-handle"
														glyph="fullscreen"
														draggable={true}
														onDragEnd={this.handleDragEnd}
														onDragStart={this.handleDragStart}
													/>
												</div>
											}
											<Glyphicon className="get-audit" role="button" glyph="info-sign" onClick={this.handleShowBudgetAuditModal.bind(this, budgetItem.categoryId, budgetItem.currencyId)} />
										</td>
										<td className={classNames({ "text-danger": budgetItem.amount < 0 }, {"text-success": budgetItem.amount > 0 })}>
											{AccountingHelper.formatMoney(budgetItem.amount, budgetItem.currencyId)}
										</td>
										<td>{category.name}</td>
									</tr>
								);
							})}
						</tbody>
					</Table>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./Components/components/Budget.jsx